export default __webpack_public_path__ + "static/media/ABC Estilo Militar Colombiano - español e ingles.75bdf0f5.pdf";